(() => {
  function filterUrl(base, current, controls, managed, existing, native, config) {
    const url = new URL(current);
    const selected = controls.filter(Boolean);
    if (selected.some(tag=>!managed.includes(tag))) throw Error('Unknown filter value');
    const tags = [...new Set([...existing.filter(tag=>!managed.includes(tag)&&!tag.startsWith('dhsf-')), ...selected])];
    if (config?.rules) {
      const byField=new Map(config.groups.map(g=>[g.key,selected.find(tag=>g.options.some(o=>o.tag===tag))]));
      for(const rule of config.rules){const values=rule.keys.map(k=>byField.get(k));if(values.some(v=>!v))continue;const match=rule.combinations.find(c=>c.signature===values.join('+'));if(match)tags.push(match.tag);else tags.push(...config.zero);}
    }
    url.pathname = base + (tags.length ? '/' + tags.join('+') : '');
    for (const key of ['page','section_id']) url.searchParams.delete(key);
    if (native) {
      for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.')) url.searchParams.delete(key);
      if ([...native].some(([key])=>key==='sort_by')) url.searchParams.delete('sort_by');
      for (const [key,value] of native) if ((key.startsWith('filter.') || key==='sort_by') && value!=='') url.searchParams.append(key,value);
    }
    url.hash='main-collection-filters';
    return url.href;
  }
  if (typeof module!=='undefined') module.exports={filterUrl};
  if (typeof document==='undefined') return;
  const configNode=document.getElementById('DhsFilterState');
  if (!configNode) return;
  const state=JSON.parse(configNode.textContent);
  const managed=state.config.groups.flatMap(g=>g.options.map(o=>o.tag));
  // Shopify omits current_tags on empty results; the scoped route retains them.
  if(location.pathname.startsWith(state.base+'/')) state.current=decodeURIComponent(location.pathname.slice(state.base.length+1)).split('+');
  const hydratedControls=new WeakSet();
  function refreshControls() { document.querySelectorAll('[data-dhs-filter-controls]').forEach(controls=>{
    if(hydratedControls.has(controls)) return;
    hydratedControls.add(controls);
    const active=controls.querySelector('.dhs-spec-filters__active');
    active.replaceChildren();
    state.config.groups.forEach(group=>{
      const option=group.options.find(o=>state.current.includes(o.tag));
      const select=controls.querySelector(`[data-dhs-field="${group.key}"]`);
      select.value=option?.tag||'';
      if(!option) return;
      select.closest('details').open=true;
      const span=document.createElement('span');span.className='dhs-spec-filters__selected';span.dataset.removeField=group.key;
      const link=document.createElement('a');link.textContent=group.label+': '+option.label;
      const remaining=state.config.groups.map(g=>g.options.find(o=>o.tag!==option.tag&&state.current.includes(o.tag))?.tag||'');
      link.href=filterUrl(state.base,location.href,remaining,managed,state.current,null,state.config);
      span.append(link);active.append(span);
    });
    if(active.childElementCount){const clear=document.createElement('a');clear.className='dhs-spec-filters__clear';clear.textContent='Clear filters';const url=new URL(location.href);url.pathname=state.base;for(const key of [...url.searchParams.keys()])if(key.startsWith('filter.')||key==='page'||key==='section_id')url.searchParams.delete(key);url.hash='main-collection-filters';clear.href=url.href;active.append(clear);}
  }); }
  refreshControls();
  const filterRoot=document.getElementById('main-collection-filters');
  if(filterRoot){const observer=new MutationObserver(()=>{observer.disconnect();refreshControls();observer.observe(filterRoot,{childList:true,subtree:true});});observer.observe(filterRoot,{childList:true,subtree:true});}
  const selections=form=>[...form.querySelectorAll('[data-dhs-field]')].map(x=>x.value);
  function refreshRemovalLinks() {
    document.querySelectorAll('.dhs-spec-filters__selected a').forEach(link=>{
      const url=new URL(link.href,location.origin);
      const remaining=url.pathname.slice(state.base.length+1).split('+');
      const selected=state.config.groups.map(g=>g.options.find(o=>remaining.includes(o.tag))?.tag||'');
      link.href=filterUrl(state.base,location.href,selected,managed,state.current,null,state.config);
    });
  }
  refreshRemovalLinks();
  function apply(form) {
    const native=new FormData(form);
    const href=filterUrl(state.base,location.href,selections(form),managed,state.current,native,state.config);
    location.assign(href);
  }
  document.addEventListener('input',event=>{
    const form=event.target.closest('form');
    if(event.target.matches('[data-dhs-field]') || (form?.id==='FacetFiltersFormMobile' && form.querySelector('[data-dhs-filter-controls]'))) event.stopImmediatePropagation();
  },true);
  document.addEventListener('change',event=>{
    if(!event.target.matches('[data-dhs-field]')) return;
    event.stopImmediatePropagation();
    const form=event.target.closest('form');
    if(form.id!=='FacetFiltersFormMobile') apply(form);
  },true);
  document.addEventListener('click',event=>{
    if(event.target.closest('.dhs-spec-filters__group > summary')) {
      event.stopImmediatePropagation();
      return;
    }
    const applyButton=event.target.closest('.mobile-facets__footer button');
    const form=applyButton?.closest('form');
    if(form?.querySelector('[data-dhs-filter-controls]')){event.preventDefault();event.stopImmediatePropagation();apply(form);return;}
    const link=event.target.closest('.dhs-spec-filters__selected a,.dhs-spec-filters__clear,facet-remove a');
    if(!link) return;
    const url=new URL(link.href,location.origin);
    if(url.origin!==location.origin || url.pathname===location.pathname) return;
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey) return;
    if(link.closest('.dhs-spec-filters__selected')) {
      const remaining=url.pathname.slice(state.base.length+1).split('+');
      const selected=state.config.groups.map(g=>g.options.find(o=>remaining.includes(o.tag))?.tag||'');
      event.preventDefault();event.stopImmediatePropagation();
      location.assign(filterUrl(state.base,location.href,selected,managed,state.current,null,state.config));return;
    }
    url.searchParams.delete('page');url.searchParams.delete('section_id');url.hash='main-collection-filters';
    event.preventDefault();event.stopImmediatePropagation();location.assign(url.href);
  },true);
})();
